import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ErrorResponse } from '../../core/models/error-response.model';

@Injectable({
	providedIn: 'root',
})
export class AuthState {
	private _isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	private _error$: BehaviorSubject<ErrorResponse | null> = new BehaviorSubject<ErrorResponse | null>(null);

	isLoading$(): Observable<boolean> {
		return this._isLoading$.asObservable();
	}

	setIsLoading(isLoading: boolean): void {
		this._isLoading$.next(isLoading);
	}

	error$(): Observable<ErrorResponse | null> {
		return this._error$.asObservable();
	}

	setError(response: ErrorResponse | null): void {
		this._error$.next(response);
	}
}
